import React,{useEffect,useState} from 'react';
import {MessageCircle,Home} from 'lucide-react';
import {HomeLanding} from './HomeLanding';
import './signed-in-landing.css';

const PREF='malvo-landing-open-chat';
type Tr=(en:string,de:string)=>string;

/** Should a signed-in visitor of the home page be asked first? No for the apps, deep links and "always open chat". */
export function shouldAskOnLanding(){
  try{
    if(location.pathname!=='/'||location.search)return false;
    if((window as any).malvoDesktop?.isDesktop||/MALVOAndroidBeta/.test(navigator.userAgent))return false;
    return localStorage.getItem(PREF)!=='1';
  }catch{return false;}
}

/** Home page for people who are already signed in: a small prompt offers the chat or staying on the page. */
export function SignedInLanding({tr,name,onOpenChat}:{tr:Tr;name:string;onOpenChat:()=>void}){
  const [asking,setAsking]=useState(true),[always,setAlways]=useState(false);
  useEffect(()=>{try{if(location.pathname!=='/')history.replaceState({},'','/');}catch{}},[asking]);
  const open=()=>{try{if(always)localStorage.setItem(PREF,'1');}catch{}onOpenChat();};
  useEffect(()=>{if(!asking)return;const key=(e:KeyboardEvent)=>{if(e.key==='Escape')setAsking(false);};addEventListener('keydown',key);return()=>removeEventListener('keydown',key);},[asking]);
  return <div className="auth-minimal is-home signed-in-landing">
    <HomeLanding tr={tr} signedIn onStart={onOpenChat} onRegister={onOpenChat}/>
    {asking&&<div className="sil-backdrop" role="presentation" onMouseDown={e=>{if(e.target===e.currentTarget)setAsking(false);}}>
      <section className="sil-card" role="dialog" aria-modal="true" aria-labelledby="sil-title">
        <img src="/icon.png" alt="" className="sil-logo"/>
        <h2 id="sil-title">You're signed in{name?<>, <span>{name}</span></>:null}</h2>
        <p>Do you want to open the chat or stay on the home page?</p>
        <div className="sil-actions">
          <button type="button" className="hl-btn red" autoFocus onClick={open}><MessageCircle size={15}/>Open chat</button>
          <button type="button" className="hl-btn light" onClick={()=>setAsking(false)}><Home size={15}/>Stay here</button>
        </div>
        <label className="sil-always"><input type="checkbox" checked={always} onChange={e=>setAlways(e.target.checked)}/><span>Always open the chat when I'm signed in</span></label>
      </section>
    </div>}
  </div>;
}
